import React from 'react'
import env from './../../environments/environment'
import SwiperCore, { Scrollbar } from 'swiper'
import {
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBContainer,
} from 'mdbreact'

import './Testimonials.scss'

SwiperCore.use([Scrollbar])

const Testimonials = () => (
  <section
    id="testimonials"
    data-on="false"
    data-md-on="true"
    style={{
      backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fbg.testimonials.jpg?alt=media)`,
      paddingTop: '60px',
      paddingBottom: '60px',
    }}
    className="rd-parallax bg-gray-base bg-image pt-5 pb-5"
  >
    <MDBContainer>
      <div className="range mb-5 pt-5 pb-5">
        <div className="cell-xs-12 text-center">
          <h2>
            <span className="sub-head-small text-white mb-5 pb-5">
              Testimonials
            </span>
          </h2>
        </div>
      </div>
      <MDBCarousel
        activeItem={1}
        length={12}
        showControls={true}
        showIndicators={false}
        className="z-depth-1 mt-5 mb-5 pt-3 pb-3"
        slide
      >
        <MDBCarouselInner>
          <MDBCarouselItem itemId="1">
            <blockquote className="quote-minimal quote-minimal-inverse mb-5">
              <div className="quote-body">
                <p>
                  <q>
                    “Seriously, these Ladies went to bat for me from the minute
                    we got the terrible news about non coverage Thursday night
                    at the 11th hour before my mastectomy. Their relentless
                    calls and emails went up the chain of command at my
                    insurance company and I have no doubt that their drive to
                    help me is part of why things have had a dramatic turnaround
                    this afternoon.
                    <br />
                    So shout out to USA benefits and Jessica Banville Rick
                    Banville and their Team!! Highly recommend!”
                    <br />– Shannon Gunn
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="2">
            <blockquote className="quote-minimal quote-minimal-inverse mb-5">
              <div className="quote-body">
                <p>
                  <q>
                    “They found us the best coverage at the best price. I highly
                    recommend them!”
                    <br /> – Dan B in Spring Hill, FL
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="3">
            <blockquote className="quote-minimal quote-minimal-inverse">
              <div className="quote-body">
                <p>
                  <q>
                    “Thank you for making Medicare simple.”
                    <br /> – Ron P in Hobbs, NM
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="4">
            <blockquote className="quote-minimal quote-minimal-inverse">
              <div className="quote-body">
                <p>
                  <q>
                    “As a traveling physician, it was important for me to have a
                    national PPO and there were none available on the
                    Marketplace. They provided what I needed and keep me updated
                    on changes that may affect me.”
                    <br /> – Dr. James M in Atlanta, GA
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="5">
            <blockquote className="quote-minimal quote-minimal-inverse">
              <div className="quote-body">
                <p>
                  <q>
                    “I’m a school teacher and my health insurance is excellent,
                    but I could not afford to insure my husband and kids until
                    now. Thank you!”
                    <br /> – Sandra J in Houston, TX
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="6">
            <blockquote className="quote-minimal quote-minimal-inverse">
              <div className="quote-body">
                <p>
                  <q>
                    “We are able to provide affordable benefits to our employees
                    now because of your creative solutions.”
                    <br /> – Tommy J in Charleston, SC
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="7">
            <blockquote className="quote-minimal quote-minimal-inverse">
              <div className="quote-body">
                <p>
                  <q>
                    “In all my years of buying health insurance as an
                    entrepreneur, I have never had anyone educate me like my
                    agent.”
                    <br /> – Brantley K in Nashville, TN
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="8">
            <blockquote className="quote-minimal quote-minimal-inverse">
              <div className="quote-body">
                <p>
                  <q>
                    “We tell all our Realtor friends to call you!”
                    <br /> – Jeannie C in Dublin, OH
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="9">
            <blockquote className="quote-minimal quote-minimal-inverse">
              <div className="quote-body">
                <p>
                  <q>
                    “Now that my employees understand the HMRA we will never go
                    without one. It makes our health plan even better.”
                    <br /> – Marty L in Jacksonville FL
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="10">
            <blockquote className="quote-minimal quote-minimal-inverse">
              <div className="quote-body">
                <p>
                  <q>
                    “I just got another check from my insurance company! I’ve
                    never heard of such a thing!”
                    <br /> – Cheryl P in Phoenix, AZ
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="11">
            <blockquote className="quote-minimal quote-minimal-inverse">
              <div className="quote-body">
                <p>
                  <q>
                    “I wanted to know who best to send a note of thanks for the
                    service Ms. Seitzer has provided. It is no secret that one
                    thing the federal gov’t is very good at is making things
                    more complicated than necessary. Medicare is a prime
                    example. Happenstance brought me into contact with Ms.
                    Seitzer. She acted as a consultant to me through the final
                    steps in making the health care decision which has become a
                    nightmare for most Americans in recent years. All health
                    care, including Medicare, has become a quagmire for those
                    forced into purchasing it. A process that can be angst
                    inducing to put it mildly. Ms. Seitzer essentially removed
                    my fears and consternation by simply being knowledgeable and
                    respectful. I’m fairly certain there were times during the
                    process that she wanted to tell me jump off the dock, but
                    she kept her head and brought around to myopic focus every
                    time. Customer Service is becoming a lost art. Ms. Seiter
                    hasn’t lost her service talents. I would like to give her
                    the highest rating you use when evaluating your partners.
                    She, in fact, should get a raise. If it were possible I’d
                    buy the company and give it to her myself. Have a great day
                    and be thankful you have Gail Seitzer on your team.”
                    <br /> – Dale L. Machesic
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="12">
            <blockquote className="quote-minimal quote-minimal-inverse mb-5">
              <div className="quote-body">
                <p>
                  <q>
                    “Seriously, these Ladies went to bat for me from the minute
                    we got the terrible news about non coverage Thursday night
                    at the 11th hour before my mastectomy. Their relentless
                    calls and emails went up the chain of command at my
                    insurance company and I have no doubt that their drive to
                    help me is part of why things have had a dramatic turnaround
                    this afternoon.
                    <br />
                    So shout out to USA benefits and Jessica Banville Rick
                    Banville and their Team!! Highly recommend!”
                    <br />– Shannon Gunn
                  </q>
                </p>
              </div>
            </blockquote>
          </MDBCarouselItem>
        </MDBCarouselInner>
      </MDBCarousel>
    </MDBContainer>
  </section>
)

export default Testimonials
